<script>
import { mapState } from 'vuex';

export default {
    name: "talents",
    data() {
        return {};
    },
    computed: {
        ...mapState(['talentMenu', 'TMActiveIndex']),
    },
    components: {
        
    },
    mounted() {
        // 获取菜单
        this.$store.dispatch('getTalentMenu');
        // 默认索引
        // this.$store.state.TMActiveIndex = [0, 0, 0];
    },
    destroyed() {},
    watch: {
        talentMenu(value) { 
            if (value.length > 0) { 
                // 菜单获取到以后，重定向到第一个
                this.redirect();
                this.getActiveIndex();
            }
        },
        // 重定向，点击‘人才’以后
        '$route.path': {
            handler: function () { 
                this.redirect();
                this.getActiveIndex();
            }
        }
    },
    methods: {
        // 重定向，点击‘人才’以后
        redirect() { 
            if (this.$route.path == '/talents') { 
                // console.log(this.talentMenu[0].children[0].link)
                this.$router.replace(this.talentMenu[0].children[0].link);
            }
        },
        // 获取对应路由的索引值
        getActiveIndex() { 
            // 完整路由
            const path = this.$route.fullPath;
            for (let i = 0; i < this.talentMenu.length; i++) {
                const item = this.talentMenu[i];
                for (let j = 0; j < item.children.length; j++) {
                    const _item = item.children[j];
                    if (_item.link == path) { 
                        // 匹配到二级
                        this.$store.state.TMActiveIndex = [i, j, 0];
                        break;
                    }else if (_item.children.length > 0) {
                        // 二级没有，检查三级
                        const index = _item.children.findIndex(v => v.link == path);
                        if (index != -1) { 
                            this.$store.state.TMActiveIndex = [i, j, index];
                            break;
                        }
                    }
                }
            }
        },
    },
};
</script>

<template>
    <div class="talents">
        <div class="banner">
            <template v-if="talentMenu.length > 0">
                <div class="layout_bg bg" :style="`background-image: url(${talentMenu[TMActiveIndex[0]].image});`"></div>
                <div class="layout_main text_shadow content">
                    <p class="title">{{talentMenu[TMActiveIndex[0]].title}}</p>
                    <p class="desc" v-html="$textToHtml(talentMenu[TMActiveIndex[0]].content)"></p>
                </div>
            </template>
        </div>
        <router-view></router-view>
    </div>
</template>

<style scoped lang="scss">
.banner{
    height: 4.8rem;
    position: relative;
    .bg{
        position: absolute;
        z-index: -1;
    }
    .content{
        height: 100%;
        flex-direction: column;
        text-align: center;
        font-size: .25rem;
        padding-top: 2rem;
        color: #fff;
        .title{
            font-size: .35rem;
            margin-bottom: .5rem;
        }
        .desc{
            padding: 0 .9rem;
        }
    }
    @media only screen and (max-width: 750px) {
        height: 6.2rem;
        .content{
            display: flex;
            padding-top: 0;
            padding-bottom: .5rem;
            justify-content: flex-end;
            .title{
                font-weight: bold;
                font-size: .42rem;
            }
            .desc{
                font-size: .28rem;
                padding: 0;
            }
        }
    }
}
</style>